import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Sizes from '../definitions/Sizes';
import Colours from '../definitions/Colours';
import Typography from '../definitions/Typography';
import MessagePropType from '../definitions/MessagePropType';
import messageToString from '../functions/messageToString';


function PillCaption({ backgroundColour, colour, message, className, ...otherProps }) {
    const intl = useIntl();

    return (
        <Container
            className={classNames(className, 'rh-text-xs', 'rh-px-0_75')}
            backgroundColour={backgroundColour}
            colour={colour}
            {...otherProps}
        >
            {messageToString(message, intl)}
        </Container>
    );
}

PillCaption.propTypes = {
    backgroundColour: PropTypes.oneOf(Object.values(Colours)),
    colour: PropTypes.oneOf(Object.values(Colours)),
    message: MessagePropType.isRequired,
    className: PropTypes.string,
};

PillCaption.defaultProps = {
    backgroundColour: Colours.STONE_LIGHT,
    colour: Colours.BLACKBERRY,
    className: undefined,
};

const Container = styled.div`
    width: fit-content;
    text-align: center;
    color: ${props => props.colour};
    background-color: ${props => props.backgroundColour};
    border-radius: ${Sizes.SPACING.QUARTER};

    strong {
        font-weight: ${Typography.WEIGHTS.MEDIUM};   // would like this to be more global
    }
`;

export default PillCaption;
